import { AbstractControl } from '@angular/forms';
import { Injectable } from '@angular/core';

export interface StateMatcher {
  matched(control?: AbstractControl | null): boolean;
}

@Injectable()
export class ErrorStateMatcher implements StateMatcher {
  public matched(control?: AbstractControl | null): boolean {
    return Boolean(control?.invalid && control.touched);
  }
}

@Injectable()
export class WarningStateMatcher implements StateMatcher {
  public matched(): boolean {
    return false;
  }
}
